import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { SectionHeading } from "./Sections";

export default function PartnerStrip() {
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    let active = true;
    api.get("/partners")
      .then(({ data }) => {
        if (!active) return;
        const withLogos = (data || []).filter((p) => p.logo);
        setLogos(withLogos);
      })
      .catch(() => { if (active) setLogos([]); });
    return () => { active = false; };
  }, []);

  if (!logos.length) return null; // never show fake/placeholder logos

  return (
    <section className="section-pad bg-secondary/30">
      <div className="container-page">
        <SectionHeading eyebrow="Our Network" title="Trusted, verified partners"
          desc="We work with authorised partners. Only verified, onboarded entities are shown." />
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {logos.map((p) => {
            const inner = (
              <div className="flex h-20 w-40 items-center justify-center rounded-xl border bg-white p-4 shadow-sm transition-all hover:-translate-y-1 hover:shadow-md">
                <img src={p.logo} alt={p.name} title={p.name}
                  className="max-h-12 max-w-full object-contain opacity-80 grayscale transition-all hover:opacity-100 hover:grayscale-0" />
              </div>
            );
            return p.website ? (
              <a key={p.id} href={p.website.startsWith("http") ? p.website : `https://${p.website}`}
                target="_blank" rel="noopener noreferrer">{inner}</a>
            ) : <div key={p.id}>{inner}</div>;
          })}
        </div>
      </div>
    </section>
  );
}
